import findAllButById from 'helpers/findAllButById'

export default function removeFloorPlan(state, action) {
  const { id } = action

  return Object.assign({}, state, {
    map: {
      ...state.map,
      floorPlans: [
        ...findAllButById({ state: state.map.floorPlans, id })
      ]
    },
    currentEntity: {
      type: "map"
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/removeFloorPlan.js